import { currentSessionProvider } from "@/api/fastapi";
import { AnalyticsIdentity } from "@/models/analytics";
import { Workspace, WorkspaceMember } from "@/models/workspace";

/**
 * Workspace, membership and sign-in facts attached to every event, per the
 * identity contract (MS-3418). Event rather than user properties because one
 * Amplitude user can act in several workspaces.
 *
 * `subscriptionStatus` comes from the workspace, and `accountId`, `baseRole`
 * and `workspaceType` from `GET /user/`, where the backend derives them; each
 * is left out when the backend did not send it.
 */
export function buildWorkspaceEventProperties(
  workspaceMember: WorkspaceMember,
  subscriptionStatus: Workspace["subscriptionStatus"],
  identity: AnalyticsIdentity | null,
): Record<string, string | number | boolean> {
  const properties: Record<string, string | number | boolean> = {
    workspaceId: workspaceMember.workspaceId,
    roleId: workspaceMember.roleId,
    subscriptionStatus,
  };

  if (identity?.accountId) {
    properties.accountId = identity.accountId;
  }
  if (identity?.baseRole) {
    properties.baseRole = identity.baseRole;
  }
  if (identity?.workspaceType) {
    properties.workspaceType = identity.workspaceType;
  }

  const authProvider = currentSessionProvider();
  if (authProvider) {
    properties.authProvider = authProvider;
  }

  return properties;
}
